
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef } from 'react';
import useClickAway from '../../../node_modules/ahooks/es/useClickAway/index.js';
import SvgClose from '../../icons/legacy/close.svg.js';
import { drawerContainer } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { m } from '../../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs.js';
import { AnimatePresence } from '../../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs.js';

var transition = {
  duration: 0.25,
  ease: "easeInOut"
};
var drawerContainerVariants = {
  open: {
    width: "100%",
    transition: _objectSpread2(_objectSpread2({}, transition), {}, {
      when: "beforeChildren"
    }),
    transitionEnd: {
      overflowY: "auto"
    }
  },
  closed: {
    overflowY: "hidden",
    width: "0%",
    transition: _objectSpread2(_objectSpread2({}, transition), {}, {
      when: "afterChildren"
    })
  }
};
var drawerContentVariants = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
};
var Drawer = function Drawer(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    footer = _ref.footer,
    children = _ref.children;
  var containerRef = useRef(null);
  useClickAway(function () {
    if (isOpen) {
      onClose();
    }
  }, containerRef);
  return jsx(AnimatePresence, null, isOpen && jsx(m.section, {
    css: drawerContainer,
    ref: containerRef,
    initial: "closed",
    animate: isOpen && "open",
    exit: "closed",
    variants: drawerContainerVariants
  }, jsx(m.div, {
    className: "content-wrapper",
    variants: drawerContentVariants
  }, jsx("div", null, jsx("header", null, jsx("div", null, title), jsx("button", {
    onClick: onClose
  }, jsx(SvgClose, {
    height: 16
  }))), jsx("p", null, children)), footer && jsx("footer", null, footer))));
};

export { Drawer as default };
//# sourceMappingURL=Drawer.js.map
